import { DataFlowDataType } from './dataflow-datatype';

export type DataFlowFilterType = 'all' | 'string' | 'math' | 'date' | 'logical' | 'input' | 'array';
export type DataFlowArgumentType = 'all' | 'functions' | 'columns' | 'parameters' | 'locals' | 'cacheSinks';

export abstract class DataFlowArgument {
    // eslint-disable-next-line
    constructor(public name: string, public type: DataFlowDataType, public filterType?: DataFlowFilterType) {
    }

    public abstract getInsertText(): string;
    public abstract getTypeIcon(): string;
    public abstract getParameterLabels(): string[];
    public abstract getParameterIcons(): string[];
    public abstract getExpressionTooltip(): string;
}
